exports.ALL = {
	'wilderness': [
		'hunting knife',
		'shovel',
		'fishing line and hook',
		'iron pot',
		'waterskin',
		'tent',
		'flint and steel',
		'bedroll',
	],
	'adventure': [
		'backpack',
		'flask of oil',
		'coil of rope',
		'lantern',
		'ten-foot pole',
		'crowbar',
		'chalk',
	],
	'military': [
		'whetstone',
		'signal whistle',
		'caltrops',
	],
	'scholar': [
		'candle',
		'pen and ink',
		'parchment',
		'sealing wax',
		'soap',
		'signet ring',
		'mirror',
		'bell',
		'textbook',
		'manuscript',
		'vial of liquid',
		'box of powder',
	],
	'holy': [
		'holy symbol',
		'holy water',
	],
	'mercantile': [
		'scale',
		'hourglass',
	],
	'craft': [
		'hammer',
		'mallet',
		'plumb bob',
		'chisel',
		'sandpaper',
		'leather strip',
		'length of string',
		'ball of wax',
	],
	'magic': [
		'spellbook',
		'scroll',
		'potion',
	],
	'medical': [
		'herbal poultice',
		'bag of leeches',
		'arrow puller',
		'anatomy chart',
		'medical textbook',
	],
	'misc': [
		'flask of ale',
		'lucky charm',
		'rolled up blanket',
		'wineskin',
		'iron key',
		'ring of keys',
	],
	'strange': [
		'cockroach',
		'moth',
		'honeycomb',
		'feather',
		'scrap of preserved flesh',
		'fragment of coded cypher',
		'cult symbol',
		'demonic symbol',
		'draconic symbol',
		'extra-planar symbol',
		'abstract sketch',
		'vial of blood',
		'animal bone',
		'rodent skull',
		'rabbit\'s foot',
		'lump of metal',
		'extracted tooth',
	],
	'sea': [
		'compass',
		'sextant',
		'coastal map',
		'hard tack',
	],
	'mount': [
		'bit and bridle',
		'saddle',
		'saddlebag',
	],
	'mount-light': [
		'riding horse',
		'draft house',
	],
	'mount-heavy': [
		'light war horse',
		'heavy war horse',
	],
};



// WEBPACK FOOTER //
// ./src/data/gear.js